export const getProjectsActivityFilterCacheKey = (activeEmployerInfo = {}) =>
  activeEmployerInfo.activeEmployerBusinessId ||
  activeEmployerInfo.activeEmployerId ||
  null;
